export const AuthActionTypes = {
  CREATE_USER_START: "CREATE_USER_START",
  CREATE_USER_SUCCESS: "CREATE_USER_SUCCESS",
  CREATE_USER_FAIL: "CREATE_USER_FAIL",

  LOGIN_USER_START: "LOGIN_USER_START",
  LOGIN_USER_SUCCESS: "LOGIN_USER_SUCCESS",
  LOGIN_USER_FAIL: "LOGIN_USER_FAIL",

  SOCIAL_LOGIN_START: " SOCIAL_LOGIN_START",
  SOCIAL_LOGIN_SUCCESS: " SOCIAL_LOGIN_SUCCESS",
  SOCIAL_LOGIN_FAIL: " SOCIAL_LOGIN_FAIL",

  GET_USER_START: " GET_USER_START",
  GET_USER_SUCCESS: " GET_USER_SUCCESS",
  GET_USER_FAIL: " GET_USER_FAIL",

  UPDATE_USER_IMAGE_START: " UPDATE_USER_IMAGE_START",
  UPDATE_USER_IMAGE_SUCCESS: " UPDATE_USER_IMAGE_SUCCESS",
  UPDATE_USER_IMAGE_FAIL: " UPDATE_USER_IMAGE_FAIL",

  UPDATE_USER_LOGIN_STATUS_START: " UPDATE_USER_LOGIN_STATUS_START",
  UPDATE_USER_LOGIN_STATUS_SUCCESS: " UPDATE_USER_LOGIN_STATUS_SUCCESS",
  UPDATE_USER_LOGIN_STATUS_FAIL: " UPDATE_USER_LOGIN_STATUS_FAIL",

  UPDATE_USER_POST_COUNT: " UPDATE_USER_POST_COUNT",
};
export const ModlasActionTypes = {
  SHOW_ADD_POST_MODAL: "SHOW_ADD_POST_MODAL",
  SHOW_COMMENTS_MODAL: "SHOW_COMMENTS_MODAL",
  SHOW_ADD_NEW_CONTACT_MODAL: "SHOW_ADD_NEW_CONTACT_MODAL",
  SHOW_NEW_CALL_ALERT: "SHOW_NEW_CALL_ALERT",
};
export const SearchActionTypes = {
  SEARCH_START: " SEARCH_START",
  SEARCH_SUCCESS: " SEARCH_SUCCESS",
  SEARCH_FAIL: " SEARCH_FAIL",
};
export const NotificationsActionTypes = {
  GET_NOTIFICATIONS_START: " GET_NOTIFICATIONS_START",
  GET_NOTIFICATIONS_SUCCESS: " GET_NOTIFICATIONS_SUCCESS",
  GET_NOTIFICATIONS_FAIL: " GET_NOTIFICATIONS_FAIL",

  READ_NOTIFICATION_START: " READ_NOTIFICATION_START",
  READ_NOTIFICATION_FAIL: " READ_NOTIFICATION_FAIL",
  READ_NOTIFICATION_SUCCESS: " READ_NOTIFICATION_SUCCESS",

  DELETE_NOTIFICATION_START: "DELETE_NOTIFICATION_START",
  DELETE_NOTIFICATION_FAIL: "DELETE_NOTIFICATION_FAIL",
  DELETE_NOTIFICATION_SUCCESS: "DELETE_NOTIFICATION_SUCCESS",
};
export const PostActionTypes = {
  GET_POSTS_START: " GET_POSTS_START",
  GET_POSTS_SUCCESS: " GET_POSTS_SUCCESS",
  GET_POSTS_FAIL: " GET_POSTS_FAIL",

  CREATE_POSTS_START: " CREATE_POSTS_START",
  CREATE_POSTS_SUCCESS: " CREATE_POSTS_SUCCESS",
  CREATE_POSTS_FAIL: " CREATE_POSTS_FAIL",

  ADD_POST_LIKE_LOCALLY: "ADD_POST_LIKE_LOCALLY",
  REMOVE_POST_LIKE_LOCALLY: "REMOVE_POST_LIKE_LOCALLY",
};
export const SotryiesActionTypes = {
  ADD_STORY_START: " ADD_STORY_START",
  ADD_STORY_SUCCESS: " ADD_STORY_SUCCESS",
  ADD_STORY_FAIL: " ADD_STORY_FAIL",

  GET_STORIES_START: " GET_STORIES_START",
  GET_STORIES_SUCCESS: " GET_STORIES_SUCCESS",
  GET_STORIES_FAIL: " GET_STORIES_FAIL",

  GET_SINGLE_USER_STORIES_START: " GET_SINGLE_USER_STORIES_START",
  GET_SINGLE_USER_STORIES_SUCCESS: " GET_SINGLE_USER_STORIES_SUCCESS",
  GET_SINGLE_USER_STORIES_FAIL: " GET_SINGLE_USER_STORIES_FAIL",

  VIEWED_STORY_START: " VIEWED_STORY_START",
  VIEWED_STORY_SUCCESS: " VIEWED_STORY_SUCCESS",
  VIEWED_STORY_FAIL: " VIEWED_STORY_FAIL",

  UPDATE_LOCAL_STORIES_DATA: " UPDATE_LOCAL_STORIES_DATA",
};
export const LikeActionTypes = {
  GET_LIKES_START: " GET_LIKES_START",
  GET_LIKES_SUCCESS: " GET_LIKES_SUCCESS",
  GET_LIKES_FAIL: " GET_LIKES_FAIL",

  LIKE_POST_START: " LIKE_POST_START",
  LIKE_POST_SUCCESS: " LIKE_POST_SUCCESS",
  LIKE_POST_FAIL: " LIKE_POST_FAIL",

  ADD_TO_FAVOURITE_START: " ADD_TO_FAVOURITE_START",
  ADD_TO_FAVOURITE_SUCCESS: " ADD_TO_FAVOURITE_SUCCESS",
  ADD_TO_FAVOURITE_FAIL: " ADD_TO_FAVOURITE_FAIL",

  GET_FAVOURITES_START: " GET_FAVOURITES_START",
  GET_FAVOURITES_SUCCESS: " GET_FAVOURITES_SUCCESS",
  GET_FAVOURITES_FAIL: " GET_FAVOURITES_FAIL",
};
export const UserProfileActionTypes = {
  GET_USER_PROFILE_START: " GET_USER_PROFILE_START",
  GET_USER_PROFILE_SUCCESS: " GET_USER_PROFILE_SUCCESS",
  GET_USER_PROFILE_FAIL: " GET_USER_PROFILE_FAIL",

  GET_USER_POSTS_START: " GET_USER_POSTS_START",
  GET_USER_POSTS_SUCCESS: " GET_USER_POSTS_SUCCESS",
  GET_USER_POSTS_FAIL: " GET_USER_POSTS_FAIL",

  GET_POSTS_BY_TAG_ON_PROFILE_START: " GET_POSTS_BY_TAG_ON_PROFILE_START",
  GET_POSTS_BY_TAG_ON_PROFILE_SUCCESS: " GET_POSTS_BY_TAG_ON_PROFILE_SUCCESS",
  GET_POSTS_BY_TAG_ON_PROFILE_FAIL: " GET_POSTS_BY_TAG_ON_PROFILE_FAIL",
  OTHER_USER_FOODANDI: "OTHER_USER_FOODANDI",
};
export const FollowUnFollowActionTypes = {
  FOLLOW_UNFOLLOW_START: " FOLLOW_UNFOLLOW_START",
  FOLLOW_UNFOLLOW_SUCCESS: " FOLLOW_UNFOLLOW_SUCCESS",
  FOLLOW_UNFOLLOW_FAIL: " FOLLOW_UNFOLLOW_FAIL",

  REMOVE_FOLLOWER_FOLLOWING_START: " REMOVE_FOLLOWER_FOLLOWING_START",
  REMOVE_FOLLOWER_FOLLOWING_SUCCESS: " REMOVE_FOLLOWER_FOLLOWING_SUCCESS",
  REMOVE_FOLLOWER_FOLLOWING_FAIL: " REMOVE_FOLLOWER_FOLLOWING_FAIL",

  GET_FOLLOWINGS_START: " GET_FOLLOWINGS_START",
  GET_FOLLOWINGS_SUCCESS: " GET_FOLLOWINGS_SUCCESS",
  GET_FOLLOWINGS_FAIL: " GET_FOLLOWINGS_FAIL",
};
export const CommentActionTypes = {
  GET_COMMENTS_START: " GET_COMMENTS_START",
  GET_COMMENTS_SUCCESS: " GET_COMMENTS_SUCCESS",
  GET_COMMENTS_FAIL: " GET_COMMENTS_FAIL",

  COMMENT_POST_START: " COMMENT_POST_START",
  COMMENT_POST_SUCCESS: " COMMENT_POST_SUCCESS",
  COMMENT_POST_FAIL: " COMMENT_POST_FAIL",

  DELETE_COMMENT_START: " DELETE_COMMENT_START",
  DELETE_COMMENT_SUCCESS: " DELETE_COMMENT_SUCCESS",
  DELETE_COMMENT_FAIL: " DELETE_COMMENT_FAIL",
};
export const MessagesActionTypes = {
  GET_CHAT_START: "GET_CHAT_START",
  GET_CHAT_SUCCESS: "GET_CHAT_SUCCESS",
  GET_CHAT_FAIL: "GET_CHAT_FAIL",

  GET_MESSAGES_START: "GET_MESSAGES_START",
  GET_MESSAGES_SUCCESS: "GET_MESSAGES_SUCCESS",
  GET_MESSAGES_FAIL: "GET_MESSAGES_FAIL",

  SEEN_ALL_MESSAGES_START: " SEEN_ALL_MESSAGES_START",
  SEEN_ALL_MESSAGES_SUCCESS: " SEEN_ALL_MESSAGES_SUCCESS",
  SEEN_ALL_MESSAGES_FAIL: " SEEN_ALL_MESSAGES_FAIL",

  UPDATE_CONTACTS_LOCALLY: "UPDATE_CONTACTS_LOCALLY",
  ADD_MESSAGE_LOCALLY: "ADD_MESSAGE_LOCALLY",
};
